import { render, staticRenderFns } from "./anasirket.vue?vue&type=template&id=3bea789e&"
import script from "./anasirket.vue?vue&type=script&lang=js&"
export * from "./anasirket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports